<template>
<div class="mdc-menu mdc-menu-surface">
    <m-list
        menu
        :items="items"
        :aria-hidden="true"
        aria-orientation="vertical"
        tabindex="-1" />
</div>
</template>

<script>
import { MDCMenu, strings } from "@material/menu";
import { Corner, strings as s } from "@material/menu-surface";
import mList from "./List.vue";
export default {
    components: { mList },
    props: {
        items: { type: Array, default: () => [] },
        anchorCorner: { type: String, default: "BOTTOM_START" }
    },
    data: () => ({
        instance: null
    }),
    mounted() {
        const menu = new MDCMenu(this.$el);
        const corner = Corner[this.anchorCorner];
        if (corner) menu.setAnchorCorner(corner);
        menu.listen(strings.SELECTED_EVENT, ({ detail }) => {
            this.$emit("selected", detail);
        });
        menu.listen(s.CLOSED_EVENT, () => {
            this.$emit("closed");
        });
        this.instance = menu;
    },
    methods: {
        open() {
            this.instance.open = true;
        }
    }
};
</script>
